import { Helmet } from "react-helmet-async";

const SITE = "Hurtler Environmental";
const BASE_URL = "https://hurtler.com";

export default function SEO({ title, description, path = "", jsonLd }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Independent Environmental Assessments`;
  const desc =
    description ||
    "Independent environmental assessment & consulting in Texas — mold, indoor air quality, water damage, building science. Headquartered in Edinburg, TX.";
  const canonical = `${BASE_URL}${path}`;
  const apiBase = process.env.REACT_APP_BACKEND_URL;
  const ogParams = new URLSearchParams({ title: title || SITE, subtitle: (desc || "").slice(0, 80) }).toString();
  const ogImage = `${apiBase}/api/og?${ogParams}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

// Reusable LocalBusiness JSON-LD (global on every page)
export const LOCAL_BUSINESS_JSONLD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${BASE_URL}/#localbusiness`,
  name: "Hurtler Environmental",
  description:
    "Independent environmental assessments, building science, and indoor air quality consulting in Texas.",
  url: BASE_URL,
  telephone: "+1-956-217-2604",
  email: "maria@hurtler.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "204 E Cano Street",
    addressLocality: "Edinburg",
    addressRegion: "TX",
    postalCode: "78539",
    addressCountry: "US",
  },
  areaServed: "Texas",
  priceRange: "$$",
};

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${BASE_URL}${it.path}`,
    })),
  };
}

export function serviceJsonLd({ name, description, slug }) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name,
    description,
    provider: { "@id": `${BASE_URL}/#localbusiness` },
    areaServed: { "@type": "State", name: "Texas" },
    url: `${BASE_URL}/services/${slug}`,
  };
}
